// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".BulkEditControls_controls__3J6W{display:flex;justify-content:flex-end;margin-top:24px}.BulkEditControls_controls__3J6W>button{margin-left:10px}", "",{"version":3,"sources":["app/storyBulkEdit/components/BulkEditControls.scss"],"names":[],"mappings":"AAAA,iCACI,YAAA,CACA,wBAAA,CACA,eAAA,CAEA,wCACI,gBAAA","file":"BulkEditControls.scss","sourcesContent":[".controls {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 24px;\n\n    > button {\n        margin-left: 10px;\n    }\n}\n"]}]);
// Exports
exports.locals = {
	"controls": "BulkEditControls_controls__3J6W"
};
module.exports = exports;
